const React = require('react')
const { useState } = require('react')
const { useNetworkConfig } = require('@contexts')
const { NETWORK_CONFIG } = require('@configs')

const { blockchainOptions, lookupOptions, toolsOptions, ecoOptions } = require('../dropdownOptions.header')

require('@styles/layouts/header/index.css')

const MobileMenu = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [isNetworkOpen, setIsNetworkOpen] = useState(false)
    const [isBlockchainOpen, setIsBlockchainOpen] = useState(false)
    const [isLookupOpen, setIsLookupOpen] = useState(false)
    const [isToolsOpen, setIsToolsOpen] = useState(false)
    // const [isEcoOpen, setIsEcoOpen] = useState(false)
    const { network } = useNetworkConfig()

    const isBlockchain_1 = network.data.type === 'Ethereum 1.0'
    const isBlockchain_2 = network.data.type === 'Ethereum 2.0'

    const options = isBlockchain_1
        ? blockchainOptions
        : blockchainOptions.concat([
              { type: 'divider' },
              { name: 'Epochs', value: 'epochs' },
              { name: 'Slots', value: 'slots' },
              { type: 'divider' },
              { name: 'Validators', value: 'validators' }
          ])

    const toggleMenu = () => {
        setIsOpen(!isOpen)
        setIsNetworkOpen(false)
        setIsBlockchainOpen(false)
        setIsLookupOpen(false)
        setIsToolsOpen(false)
        // setIsEcoOpen(false)
    }

    const toggleNetwork = e => {
        e.stopPropagation()
        setIsNetworkOpen(!isNetworkOpen)
    }

    const toggleBlockchain = e => {
        e.stopPropagation()
        setIsBlockchainOpen(!isBlockchainOpen)
    }
    const toggleLookup = e => {
        e.stopPropagation()
        setIsLookupOpen(!isLookupOpen)
    }

    const toggleTools = e => {
        e.stopPropagation()
        setIsToolsOpen(!isToolsOpen)
    }

    // const toggleEco = e => {
    //     e.stopPropagation()
    //     setIsEcoOpen(!isEcoOpen)
    // }

    const renderMenuItem = option => {
        if (option.type === 'divider') return null

        const href = option.value.startsWith('http') ? option.value : `/${network.data.shortName}/${option.value}`

        return (
            <a
                key={option.value}
                href={href}
                className='mobile-dropdown-item'
                onClick={toggleMenu}
                target={option.value.startsWith('http') ? '_blank' : undefined}
            >
                {option.iconUrl && <img src={option.iconUrl} style={{ width: '20px', marginRight: '8px' }} alt='' />}
                {option.name}
            </a>
        )
    }

    const sections = [
        {
            title: 'Blockchain',
            items: options.map(renderMenuItem),
            isOpen: isBlockchainOpen,
            onToggle: toggleBlockchain
        },
        {
            title: 'Lookup',
            items: lookupOptions.map(renderMenuItem),
            isOpen: isLookupOpen,
            onToggle: toggleLookup
        },
        {
            title: 'Tools',
            items: toolsOptions.map(renderMenuItem),
            isOpen: isToolsOpen,
            onToggle: toggleTools
        },
        // {
        //     title: 'Eco',
        //     items: ecoOptions.map(renderMenuItem),
        //     isOpen: isEcoOpen,
        //     onToggle: toggleEco
        // },
        {
            title: 'Networks',
            items: (
                <>
                    {Object.entries(NETWORK_CONFIG).map(([_, network]) => (
                        <a
                            href={`/${network.shortName}`}
                            className='mobile-dropdown-item'
                            onClick={e => {
                                e.preventDefault()
                                toggleMenu()
                                window.location.href = `/${network.shortName}`
                            }}
                            key={network.shortName}
                        >
                            {network.networkIcon && (
                                <img src={network.networkIcon} style={{ marginRight: '8px', width: '20px' }} alt='' />
                            )}
                            {network.name}
                        </a>
                    ))}
                </>
            ),
            isOpen: isNetworkOpen,
            onToggle: toggleNetwork
        }
    ]

    return (
        <div className='mobile-menu-container'>
            <button className='mobile-menu-button' onClick={toggleMenu}>
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <circle cx='12' cy='6' r='2' fill='currentColor' />
                    <circle cx='12' cy='12' r='2' fill='currentColor' />
                    <circle cx='12' cy='18' r='2' fill='currentColor' />
                </svg>
            </button>
            {isOpen && (
                <div className='mobile-dropdown'>
                    {sections.map((section, idx) => (
                        <div className='mobile-dropdown-section'>
                            <div className='mobile-dropdown-header'>
                                <button className='network-toggle' onClick={section.onToggle}>
                                    <svg
                                        width='16'
                                        height='16'
                                        viewBox='0 0 16 16'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M4 6L8 10L12 6'
                                            stroke='currentColor'
                                            strokeWidth='2'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                        />
                                    </svg>
                                </button>
                                <div className='mobile-dropdown-title'>{section.title}</div>
                            </div>
                            {section.isOpen && <div className='mobile-dropdown-items'>{section.items}</div>}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

module.exports = { MobileMenu }
